// Wave 20.49h — logged-out visitors on a protected route bounce
// straight to /login (with a next= param) instead of rendering
// the protected page and showing "please sign in" copy.
//
// Wrap the element of any protected route in App.tsx:
//   { path: '/feed', element: <RequireAuth><Feed /></RequireAuth> }

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY || 'aero.chat_token';

function hasToken(): boolean {
  try {
    return !!localStorage.getItem(TOKEN_KEY);
  } catch {
    return false;
  }
}

export default function RequireAuth({ children }: { children: React.ReactElement }) {
  const location = useLocation();
  if (!hasToken()) {
    const next = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return children;
}
